export const parseFormattedNumber = (value) => {
    if (!value) return 0;

    return Number(
        value.toString().replace(/\s/g, "")
    );
};
